import { render, staticRenderFns } from "./radio-tertiary.vue?vue&type=template&id=467d5a3c&scoped=true&"
import script from "./radio-tertiary.vue?vue&type=script&lang=js&"
export * from "./radio-tertiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467d5a3c",
  null
  
)

export default component.exports